export function createMerchantClient(transport) {
    return {
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * List this tenant's merchants, by trading name
         *
         * Requires scope: merchant:read
         */
        listMerchants(status, limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/merchants",
                query: { status: status, limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /v1/merchants
         *
         * Requires scope: merchant:create
         */
        createMerchant(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/merchants",
                body,
                options,
            });
        },
        /**
         * GET /v1/merchants/{merchantId}
         *
         * Requires scope: merchant:read
         */
        getMerchant(merchantId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/merchants/${encodeURIComponent(merchantId)}`,
                options,
            });
        },
        /**
         * PATCH /v1/merchants/{merchantId}
         *
         * Requires scope: merchant:update
         */
        updateMerchant(merchantId, body, options) {
            return transport.request({
                method: "PATCH",
                path: `/v1/merchants/${encodeURIComponent(merchantId)}`,
                body,
                options,
            });
        },
        /**
         * POST /v1/merchants/{merchantId}/status
         *
         * Requires scope: merchant:lifecycle
         */
        changeMerchantStatus(merchantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/merchants/${encodeURIComponent(merchantId)}/status`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=merchant.js.map